import Resource from 'api/resource';

class RoleResource extends Resource {
  constructor() {
    super('roles/');
  }
}

export { RoleResource as default };
